import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldSet} from '@simpli/meta-schema'
import {ICategoryCollectionResourcesHolder} from '@/model/collection/CategoryCollection'
import {Category} from '@/model/resource/Category'

export class FilterCategorySchema extends DefaultSchema
  implements ICategoryCollectionResourcesHolder {
  readonly name = 'FilterCategory'

  readonly fieldSet: FieldSet<Category> = {}
}
